import SchoolSidebar from "./SchoolSidebar";
import "./SchoolSidebar.css";

export default function SchoolLayout({ children }) {
  return (
    <div className="school-layout">
      <SchoolSidebar />
      <div className="school-content">{children}</div>
    </div>
  );
}